import React from "react";
import { Link, useHistory } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import LogoTV from "./LogoTV.png";
import HomeIcon from '@mui/icons-material/Home';

const Navbar = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const history = useHistory();

  if (!authState) {
    return <div>Loading ...</div>;
  }

  const handleLogin = async () => history.push("/login");

  const handleLogout = async () => oktaAuth.signOut();

  console.log(authState)

  return (
    <>
      <AppBar position="static" className="headtop">
        <Toolbar variant="dense">
          <img
            style={{
              width: "9rem",
              height: "1.8rem",
            }}
            src={LogoTV}
            alt="img"
          />
          <Typography
            variant="h5"
            noWrap
            component="div"
            sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
          >
            <b style={{ paddingLeft: "12px" }}>CTB Admin Tool</b>
          </Typography>
        </Toolbar>
      </AppBar>

      <div className="topnav">
        {authState.isAuthenticated ? (
          <>
            <Link to="/"><HomeIcon /></Link>
            <Link to="/asssortment">Assortment</Link>
            <Link to="/category">Category</Link>
            <Link to="/sub-category">Sub Category</Link>
            <Link to="/fixtures">Fixtures</Link>
            <Link to="/view-planogram">Assortment Planogram</Link>
            <Link to="/subcategory-restrict">Subcategory Restriction</Link>
            <div style={{ float: "right", margin: "12px" }}>
              <button id="logout-button" type="button" onClick={handleLogout}>
                <b>LOGOUT</b>
              </button>
            </div>
          </>
        ) : (
          <>
            <Link to="/"><HomeIcon /></Link>
            <div style={{ float: "right", margin: "12px" }}>
              <button id="login-button" type="button" onClick={handleLogin}>
                <b>LOGIN</b>
              </button>
            </div>
          </>
        )}

      </div>
    </>
  );
};

export default Navbar;
